export class StatusOrdenServicio {
    idStatusOrdenServicio: number;
    descripcion: string;
    orden: number;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/statusOrdenServicio.ts